// extracted by mini-css-extract-plugin
export default {"treeSelect":"styles_treeSelect__4RYQs"};